import { ArrowUp } from "lucide-react";
import { scrollToSection } from "@/components/Nav";
import KeyButton from "@/components/KeyButton";

export default function Footer() {
  return (
    <footer
      data-testid="footer-section"
      className="relative overflow-hidden bg-[#0D0D0D] px-6 pb-10 pt-20 text-[#F4F3EF] sm:px-10"
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="flex flex-wrap items-start justify-between gap-10">
          <img
            data-testid="footer-logo"
            src="/logo-white.png"
            alt="Leevé Media"
            className="h-5 w-auto sm:h-6"
          />
          <div className="flex gap-8">
            <a
              data-testid="footer-social-instagram"
              href="https://www.instagram.com/leeve.media/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono-label text-[10px] tracking-[0.25em] text-[#F4F3EF]/60 transition-colors duration-300 hover:text-[#F4F3EF]"
            >
              INSTAGRAM
            </a>
          </div>
          <KeyButton
            testid="footer-back-to-top-button"
            compact
            onClick={() => scrollToSection("#top")}
          >
            <span className="flex items-center gap-2">
              TOP
              <ArrowUp size={13} />
            </span>
          </KeyButton>
        </div>

        <p
          aria-hidden
          className="pointer-events-none mt-16 select-none whitespace-nowrap font-serif-display text-[18vw] italic leading-none text-transparent lg:text-[15vw]"
          style={{ WebkitTextStroke: "1px rgba(244,243,239,0.14)" }}
        >
          Leevé media
        </p>

        <div className="mt-4 flex flex-wrap items-center justify-between gap-4 border-t border-[#F4F3EF]/15 pt-6 font-mono-label text-[9px] tracking-[0.25em] text-[#F4F3EF]/50">
          <span>© 2026 LEEVÉ MEDIA — ALL RIGHTS RESERVED</span>
          <span>AASHISH@LEEVEMEDIA.COM — @LEEVE.MEDIA</span>
        </div>
      </div>
    </footer>
  );
}
